/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api/featureCategoriesApi.ts
 🗓️ Created: 2025-01-22
 🧩 Description:
    API calls for fetching Feature Code Categories.
────────────────────────────────────────────────────────────────*/

import { buildApiUrl, getApiHeaders } from '../../../config/api';
import type { FeatureCategory } from '../types';

export const fetchFeatureCategories = async (
  tenantSlug?: string,
  userId?: string,
  domainId?: number,
  domainName?: string
): Promise<FeatureCategory[]> => {
  const queryParams = new URLSearchParams();
  if (domainId && !isNaN(domainId)) queryParams.append('domainId', domainId.toString());
  if (domainName) queryParams.append('domainName', domainName);
  const qs = queryParams.toString();
  const url = buildApiUrl(`/api/telephony/feature-codes/categories${qs ? `?${qs}` : ''}`);
  const headers = getApiHeaders(tenantSlug, userId);

  const response = await fetch(url, { headers });

  if (response.ok) {
    const result = await response.json();
    if (result.success && Array.isArray(result.data)) {
      return result.data.sort((a: FeatureCategory, b: FeatureCategory) =>
        a.name.localeCompare(b.name)
      );
    }
  }

  return [];
};

